module.exports = __webpack_public_path__ + "30db37e4961514fb2944b0f6bb8dd894.MP3";